import { createBrowserRouter } from 'react-router-dom';
import BookingPage from '@/pages/booking-page';
import ConfirmationPage from '@/pages/confirmation-page';
import LoginPage from '@/features/auth/pages/login-page';
import RegisterPage from '@/features/auth/pages/register-page';
import AppointmentsPage from '@/pages/appointments-page';
import AccountPage from '@/pages/account-page';
import { ProtectedRoute } from '@/features/auth/components/protected-route';
import { ClientLayout } from '@/components/layout/client-layout';

export const router = createBrowserRouter([
  { path: '/', element: <BookingPage /> },
  { path: '/confirmacao', element: <ConfirmationPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/registo', element: <RegisterPage /> },
  {
    element: (
      <ProtectedRoute>
        <ClientLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: '/minhas-marcacoes', element: <AppointmentsPage /> },
      { path: '/minha-conta', element: <AccountPage /> },
    ],
  },
]);
